import { isRatingInputId } from './is-rating-input';
import { getRatingHintByInputId } from './get-rating-hint-by-input-id';

type GetRatingHintByInputParams = {
    input: Pick<HTMLInputElement, 'id'>;
};
export const getRatingHintByInput = ({ input }: GetRatingHintByInputParams) => {
    const { id: ratingId } = input;
    if (!isRatingInputId(ratingId)) return 'Bitte wählen';
    return getRatingHintByInputId(ratingId);
};
